import React from 'react';

const ScrollUpIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10 3.33334L17.5 10.8333L15.8333 12.5L10 6.66667L4.16667 12.5L2.5 10.8333L10 3.33334Z"
      fill="currentColor"
    />
    <rect x="9" y="6" width="2" height="14" fill="currentColor" />
  </svg>
);

export default ScrollUpIcon;



// WEBPACK FOOTER //
// ./src/components/icons/ScrollUpIcon.js